import { UserManager, WebStorageStateStore } from 'oidc-client-ts';
import { getConfig, buildScope } from './config';
import { setToken } from './tokenAccess';

let manager: UserManager | null = null;

/** Lazy singleton — requires loadConfig() to have run. */
export function getUserManager(): UserManager {
  if (manager) return manager;
  const cfg = getConfig();
  // Redirect URIs are deterministic from where the app is served; the Zitadel
  // app only needs them on its allow-list, so they are not part of config.json.
  const base = import.meta.env.BASE_URL; // '/' (the app is served at the host root)
  manager = new UserManager({
    authority: cfg.authority,
    client_id: cfg.clientId,
    redirect_uri: `${globalThis.location.origin}${base}auth/callback`,
    post_logout_redirect_uri: `${globalThis.location.origin}${base}`,
    response_type: 'code',
    scope: buildScope(cfg.projectId),
    userStore: new WebStorageStateStore({ store: globalThis.sessionStorage }),
    automaticSilentRenew: true,
  });
  manager.events.addUserLoaded((user) => setToken(user.access_token));
  manager.events.addUserUnloaded(() => setToken(null));
  return manager;
}

/** Test-only: clear the cached UserManager between cases. */
export function __resetUserManagerForTest(): void {
  manager = null;
}
